export default async (axios, searchValue, page, limit, params = {}) => {
    // Endpoint admin (OAuth) equivalente ao GetEnclosureListingForCore/{TOKEN}.
    // Ajuste o caminho caso o backend use outra rota.
    const response = await axios.get('/Barrier/GetEnclosureListing');

    const { data } = response;

    return {
        metadata: {
            page: 1,
            pages: 1,
        },
        result: data.map(item => ({
            label: item.label,
            key: item.id,
            item,
        })),
    };
};
